export default "__VITE_ASSET__DdDysVAC__"